<h2 class="h2-bold">{{'Your account has been created' | translate}}</h2>
<p class="m-t-1 p2">{{'You\'re all set! Enjoy early access to sales, new collections, faster checkout, and more. Tap the
   person icon in the navigation to view your account after checking out.' | translate}}</p>